import { useState, useEffect } from 'react';

import { data } from './data/data_02_pistopaikka'
import { data2 } from './data/data_02_pistosyvyys'
import Scene_02_pistopaikka_1 from './Scene_02_pistopaikka_1'
import Scene_02_pistopaikka_2 from './Scene_02_pistopaikka_2'
import Scene_02_pistosyvyys from './Scene_02_pistosyvyys.js'
import Scene_02_epilogi from './Scene_02_epilogi.js'
import Scene_get_out from '../Scene_get_out.js'
import Scene_get_out2 from '../Scene_get_out2.js'

const Scenepohja_02 = ({ scoreHandler_main, visibilityHandler_main, soundsOn, enimi, ohjNimi }) => {

    const [visible_pistopaikka_1, setVisible_pistopaikka_1] = useState(true)
    const [visible_pistopaikka_2, setVisible_pistopaikka_2] = useState(false)
    const [visible_pistosyvyys, setVisible_pistosyvyys] = useState(false)
    const [visible_get_out, setVisible_get_out] = useState(false)
    const [visible_get_out2, setVisible_get_out2] = useState(false)
    const [visible_02_epilogi, setVisible_02_epilogi] = useState(false)


    const [pistopaikkaPisteet, setPistopaikkaPisteet] = useState(0)
    const [pistosyvyysPisteet, setPistosyvyysPisteet] = useState(0)


    // const [yritystenLkm, setYritystenLkm] = useState(0)

    const hideAllScenes = () => {
        setVisible_pistopaikka_1(false)
        setVisible_pistopaikka_2(false)
        setVisible_pistosyvyys(false)
        setVisible_get_out(false)
        setVisible_get_out2(false)
        setVisible_02_epilogi(false)

    }



    const visibilityHandler = (valinta) => {

        hideAllScenes()

        switch (valinta) {

            case "pistopaikka ok":
                console.log("visiblityhandler, pistopaikka ok");
                setVisible_pistosyvyys(true)

                break;
            case "pistopaikka ei ok":
                console.log("Teijan pitää neuvoa pistopaikka ");
                setVisible_pistopaikka_2(true)
                break;

            case "ulos":
                setVisible_get_out(true)
                break;
            case "syvyys ok":
                setVisible_02_epilogi(true)
                break;
            case "syvyys ei ok":
                setVisible_get_out2(true)
                break;


        }

    }




    const scoreHandler = (msg) => {

        if (msg == "itse ok") {
            console.log("scorehandler, piste saatu");
            visibilityHandler("pistopaikka ok")
            setPistopaikkaPisteet(1)
            scoreHandler_main(data.optiot[0], data.scene, data.maxp)
            // (optio, scene, sceneMaxp)
        }
        else if (msg == "itse ei ok") {
            visibilityHandler("pistopaikka ei ok")
        }



        else if (msg == "Teijan avulla ok") {
            scoreHandler_main(data.optiot[1], data.scene, data.maxp)
            visibilityHandler("pistopaikka ok")

        }
        else if (msg == "Teijan avulla ei ok") {
            console.log("game over");
            scoreHandler_main(data.optiot[1], data.scene, data.maxp)
            visibilityHandler("ulos")
        }
        else if (msg == "syvyys ok") {
            // syvyys oikea
            scoreHandler_main(data2.optiot[0], data2.scene, data2.maxp)
            visibilityHandler(msg)

        }
        else if (msg == "syvyys ei ok") {
            // syvyys väärä
            scoreHandler_main(data2.optiot[1], data2.scene, data2.maxp)

            visibilityHandler(msg)
        }




    }



    return (

        <div>

            {
                visible_pistopaikka_1 ? <Scene_02_pistopaikka_1 scoreHandler={scoreHandler} soundsOn={soundsOn} /> : null
            }
            {
                visible_pistopaikka_2 ? <Scene_02_pistopaikka_2 scoreHandler={scoreHandler} soundsOn={soundsOn} /> : null
            }
            {
                visible_pistosyvyys ? <Scene_02_pistosyvyys scoreHandler={scoreHandler} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visible_get_out ? <Scene_get_out visibilityHandler={visibilityHandler_main} soundsOn={soundsOn} /> : null
            }
            {
                visible_get_out2 ? <Scene_get_out2 visibilityHandler={visibilityHandler_main} soundsOn={soundsOn} /> : null
            }
            {
                visible_02_epilogi ? <Scene_02_epilogi visibilityHandler={visibilityHandler_main} soundsOn={soundsOn} /> : null
            }


        </div>



    )


}

export default Scenepohja_02